// versionNumber.js
var VersionNumber = pc.createScript('versionNumber');

VersionNumber.prototype.initialize = function () {
    this.entity.element.text = gameVersion;
};


